// modules
import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setMedicalDeviceOrderingList,
  setMedicalDeviceOrderingPatientAddresses,
  setMedicalDeviceOrderingPatientProfile,
  setMedicalDeviceOrderingTypeList
} from 'src/store/modules/actions'
import {
  getMedicalDeviceTypes,
  getPatientAddresses,
  getPatientProfile
} from 'src/store/modules/common'

// constants
import {
  DATE_TIME_FORMAT_FOR_SERVER,
  MEDICAL_DEVICE_ORDERING_GET_LIST
} from 'src/constants'
import { exportReport } from 'src/utils/Functions'

export const fetchMedicalDeviceOrderingList =
  (config = {}) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: MEDICAL_DEVICE_ORDERING_GET_LIST,
          params,
          query
        }
      })

      dispatch(setMedicalDeviceOrderingList(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const exportMedicalDeviceOrderingList =
  (config = {}) =>
  async () => {
    await exportReport(
      config,
      `device_orders_list_${moment().format(DATE_TIME_FORMAT_FOR_SERVER)}.xls`
    )
  }

export const fetchMedicalDeviceOrderingPatientAddresses =
  (config = {}) =>
  async (dispatch) => {
    const patientAddresses = await getPatientAddresses(config)

    dispatch(setMedicalDeviceOrderingPatientAddresses(patientAddresses))
  }

export const fetchMedicalDeviceOrderingPatientProfile =
  (config = {}) =>
  async (dispatch) => {
    const patientProfile = await getPatientProfile(config)

    dispatch(setMedicalDeviceOrderingPatientProfile(patientProfile))
  }

export const fetchMedicalDeviceOrderingTypeList =
  (config = {}) =>
  async (dispatch) => {
    const typeList = await getMedicalDeviceTypes(config)

    dispatch(setMedicalDeviceOrderingTypeList(typeList))
  }
